<app-slider></app-slider>
<div class="container py-5">
  <h2 class="mb-4 text-center text-primary">Preguntas Frecuentes</h2>

  <ngb-accordion #acc="ngbAccordion" [closeOthers]="true">
    <ngb-panel *ngFor="let faq of faqs; let i = index" [id]="'panel-' + i">
      <ng-template ngbPanelTitle>
        <div class="accordion-header d-flex justify-content-between align-items-center p-3 ">
          <span class="fw-semibold">{{ faq.pregunta }}</span>
          <i class="bi"
            [ngClass]="{'bi-chevron-down': !acc.isExpanded('panel-' + i), 'bi-chevron-up': acc.isExpanded('panel-' + i)}"></i>
        </div>
      </ng-template>

      <ng-template ngbPanelContent>
        <div class="p-3 border rounded shadow-sm mt-2 bg-white">
          {{ faq.respuesta }}
        </div>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>
<app-footer [conf]="conf"></app-footer>